export default __webpack_public_path__ + "static/media/hand-splash-desktop.c285d404.png";